import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Modal, Button, Spinner } from "flowbite-react";
import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import TextInput from "./TextInput";

export default function ValidateUserModal({
  user,
  enabled,
  handleSubmit,
  onClose,
  error,
}) {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  useEffect(() => {
    axiosInstance
      .get("/v51/companies")
      .then((res) => {
        setCompanies(
          res.data?.map((company) => ({
            label: company.name,
            value: company.id,
          })),
        );
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <div className="container z-50">
      <Modal
        show={enabled}
        onClose={() => {
          onClose();
        }}
      >
        <Modal.Header>Validate user</Modal.Header>
        <Modal.Body className="items-center justify-center dark:text-white">
          <form className="mx-auto max-w-md items-center justify-center space-y-5">
            {companies?.length === 0 ? (
              <Spinner />
            ) : (
              <>
                <TextInput label={"Email"} value={user.email} enabled={false} />
                <TextInput
                  label="Last name"
                  value={user.lastName}
                  enabled={false}
                />
                <TextInput
                  label="First name"
                  value={user.firstName}
                  enabled={false}
                />
                <TextInput
                  label={"Declared company at registration"}
                  value={user.company}
                  enabled={false}
                />
                <label>
                  In order to validate the user asign him to an existing company
                </label>
                <Autocomplete
                  value={selectedCompany}
                  onChange={(event, newValue) => {
                    setSelectedCompany(newValue);
                  }}
                  disablePortal
                  id="combo-box"
                  options={companies}
                  sx={{ width: 300 }}
                  renderInput={(params) => {
                    return <TextField {...params} label="Company Name" />;
                  }}
                />
              </>
            )}
          </form>
          {error && <p className="text-center text-red-500">{error}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => handleSubmit(selectedCompany)}>
            Validate
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
